import { Component, OnInit,ViewChild } from '@angular/core';
import { ActivatedRoute  } from '@angular/router';
import { PatientService ,UserService} from '../../shared';

import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';

import { User, Errors } from '../../shared/models';
import {ShowHideInput} from '../../shared'

import { Keepalive } from '@ng-idle/keepalive';
import { Idle } from '@ng-idle/core';
import { environment } from '../../shared/config/app-config';


@Component({
  selector: 'app-loginfromonboard',
  templateUrl: './loginfromonboard.component.html',
  styleUrls: ['./loginfromonboard.component.css']
})
export class LoginfromonboardComponent implements OnInit {

  idle: any;
  temuser: string;

  userName:string;
  userpass:string;
  pswfID:string;
  argnData:any;
  temPass:string;
  session: boolean =false;
  authType: string = '';
  title: string = '';
  errors: Errors = new Errors();
  isSubmitting = false;
  authForm: FormGroup;
  type:string ='email';
  public idletime:any = environment.idletime;
  public setidletime:any = environment.timeset;
  @ViewChild(ShowHideInput) input: ShowHideInput;
  show = false;
  username:any ="";
  password:any ="";
  strykerId:any="";
  code:any;
  ipBlocked = true;
  ipBlockedDetails:any;

  constructor(private patientservice: PatientService,private userService:UserService,private activatedRoute: ActivatedRoute) {

    this.activatedRoute.params
    .subscribe(data=>{
        ////console.log(data)
       this.argnData = data;
       this.userName=decodeURIComponent(this.argnData.uname);
       this.userpass=decodeURIComponent(this.argnData.upass);
       this.strykerId = decodeURIComponent(this.argnData.strkerId);
       
     })

   }
  ngOnInit() {
    this.submitForm()
  }
  submitForm() {
    this.userService.purgeAuth();
    this.temuser = atob(this.userName)
    this.temPass = this.userpass
    window.localStorage['officeUser'] = this.strykerId
    ////console.log(this.temuser,this.temPass)
        const credentials = {
          'username': this.temuser,
          'password': this.temPass,
          'captcha':'',
          'mode':'',
          'usermode':localStorage.getItem('userMode')?atob(localStorage.getItem('userMode')):'c',
          'forcelogin':'true',
          "officeUser" : this.strykerId,
          "switchPortal" : 1
        }
        this.userService
        .attemptAuthFromOB(credentials)
        .subscribe(
          data => {

          },
          err => {
            
          }
        );
    
    
    
  }
}
